import React, { Suspense } from 'react';
import { observer } from 'mobx-react';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';

import { Route, Switch } from 'react-router-dom';
import * as paths from 'Paths';


const AccountPromptRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/console/account-prompt" */
    'routes/Console/AccountPromptRoute'
  )
));

const DetectAccountRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/console/detect-account" */
    'routes/Console/DetectAccountRoute'
  )
));

const StoreConnExistsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/console/store-connection-exists" */
    'routes/Console/StoreConnExistsRoute'
  )
));

const DuplicateConnExistsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/console/duplicate-connection-exists" */
    'routes/Console/DuplicateConnExistsRoute'
  )
));

const CatalogRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/console/catalog" */
    'routes/Console/CatalogRoute'
  )
));


const ProvisionAccountRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/console/provision-account" */
    'routes/Console/ProvisionAccountRoute'
  )
));


const ProvisionProductRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/console/provision-product" */
    'routes/Console/ProvisionProductRoute'
  )
));


const MarketingPlatformConnectionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/console/marketing-platform-connections" */
    'routes/Console/MarketingPlatformConnectionsRoute'
  )
));

const MarketingPlatformOverviewRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/console/marketing-platform-overview" */
    'routes/Console/MarketingPlatformOverviewRoute'
  )
));

const MarketingPlatformAnalyticsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/console/marketing-platform-analytics" */
    'routes/Console/MarketingPlatformAnalyticsRoute'
  )
));



const getConsoleRoutes = () => {
  return [
    {path: paths.getPathAccountPrompt(), component: AccountPromptRoute},
    {path: paths.getPathDetectAccount(), component: DetectAccountRoute},
    {path: paths.getPathStoreConnectionExists(), component: StoreConnExistsRoute},
    {path: paths.getPathDuplicateConnectionExists(), component: DuplicateConnExistsRoute},

    {path: paths.getPathCatalog(), component: CatalogRoute},
    {path: paths.getPathProvisionAccount(), component: ProvisionAccountRoute},
    {path: paths.getPathProvisionProduct(), component: ProvisionProductRoute},

    {path: paths.getPathMarketingPlatformConnections(), component: MarketingPlatformConnectionsRoute},
    {path: paths.getPathMarketingPlatformOverview(), component: MarketingPlatformOverviewRoute},
    {path: paths.getPathMarketingPlatformAnalytics(), component: MarketingPlatformAnalyticsRoute},
  ]
}


export { getConsoleRoutes };
